import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from '../../../common';
import JoinGame from '../JoinGame';

export default class JoinGameModal extends Component {
  static propTypes = {
    isModalOpened: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
  };

  onJoinGameModalClose = () => {
    const {onModalClose} = this.props;
    onModalClose();
  }

  render() {
    const {isModalOpened} = this.props;

    return (
      <Modal
        title="Let’s get started!"
        isOpen={isModalOpened}
        onClose={this.onJoinGameModalClose}
        textAlign="center"
        customClasses="modal_header_fixed"
      >
        <JoinGame {...this.props}/>
      </Modal>
    );
  }
}
